import { isAxiosError } from 'axios';

/**
 * Extract a user-presentable message from an unknown thrown value.
 * Replaces the `catch (e: any) { e.message }` pattern: `catch` variables are
 * `unknown` under strict TS, and reaching into non-Error throws crashed the
 * catch block itself.
 */
export const getErrorMessage = (error: unknown, fallback = 'Something went wrong'): string => {
  if (isAxiosError(error)) {
    const responseMessage = (error.response?.data as { message?: unknown } | undefined)?.message;
    if (typeof responseMessage === 'string' && responseMessage) return responseMessage;
    return error.message || fallback;
  }
  if (error instanceof Error) return error.message || fallback;
  if (typeof error === 'string' && error) return error;
  return fallback;
};
